import React, {lazy, FC, Suspense, useState, useEffect} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import ConfigurationRoutes from '../modules/configuration/ConfigurationRoutes'
import {useAuth} from '../modules/auth'
import TemplatesMain from '../modules/templates/TemplatesMain'
import TeamMembersMain from '../modules/team_members/TeamMembersMain'
import MyPods from '../modules/my_account/MyPods'
import MyInvitesTable from '../modules/my_account/MyInvites'
import MyProfile from '../modules/my_account/MyProfile'
import TempInfo from '../modules/templates/templateInfo/TempInfo'
import BillingsPage from '../modules/subscriptions/BillingsPage'
import secureLocalStorage from 'react-secure-storage'
import {DocsRoute} from '../modules/documents/DocsRoute'
import {ApiTokensMain} from '../modules/API_Tokens/ApiTokensMain'
import {PendingRequests} from '../modules/my_account/PendingRequests'
import Subscriptions from '../modules/subscriptions/Subscriptions'

const PrivateRoutes = () => {
  const {currentUser} = useAuth()

  const currentPod: any = localStorage.getItem('currentPodCode')

  let podId: string | undefined
  if (currentUser?.pods_list?.length) {
    if (typeof currentPod === 'string') {
      const podExists = currentUser.pods_list.some(
        (each) => JSON.stringify(each.pod_code) === currentPod
      )
      podId = podExists ? JSON.parse(currentPod) : currentUser.pods_list[0].pod_code
    } else {
      podId = currentUser.pods_list[0].pod_code
    }
  }

  let currPod: string | undefined | null
  if (currentUser?.pods_list?.length) {
    if (typeof currentPod === 'string') {
      const podExists = currentUser.pods_list.some(
        (each) => JSON.stringify(each.pod_code) === currentPod
      )
      currPod = podExists ? JSON.parse(currentPod) : null
    } else {
      currPod = null
    }
  }
  // const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  // const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  // const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  // const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  // const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  // const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  // const isFirstPodSet = localStorage.getItem('IsSetFirstPod')

  const NavigateInitial: React.FC<{element: React.ReactNode}> = ({element}) => {
    const podsList: any = secureLocalStorage.getItem('jb_pods_list')

    const isFirstPodAvailable = podsList?.length > 0
    return !isFirstPodAvailable ? (
      <Navigate to='/pending-requests' replace />
    ) : (
      <React.Fragment>{element}</React.Fragment>
    )
  }

  const searchParams = new URLSearchParams(window.location.search)
  const redirectParam: string = decodeURIComponent(searchParams?.get('redirect') ?? '')

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        {/* <Route path='auth/*' element={<Navigate to={`/${podId}/dashboard`} />} /> */}
        <Route path='auth/*' element={<Navigate to={redirectParam || '/pending-requests'} />} />
        {/* Pages */}
        <Route
          path={`/:id/dashboard`}
          element={<NavigateInitial element={<DashboardWrapper />} />}
        />
        <Route path='builder' element={<BuilderPageWrapper />} />
        {/* Lazy Modules */}

        <Route
          path={`/:id/subscriptions`}
          element={
            <SuspensedView>
              <BillingsPage />
            </SuspensedView>
          }
        />

        <Route
          path={`/:id/manage-subscriptions`}
          element={
            <SuspensedView>
              <Subscriptions />
            </SuspensedView>
          }
        />

        <Route
          path={`/my-pods`}
          element={
            <SuspensedView>
              <MyPods />
            </SuspensedView>
          }
        />
        <Route
          path={`/my-invites`}
          element={
            <SuspensedView>
              <MyInvitesTable />
            </SuspensedView>
          }
        />
        <Route
          path={`/my-profile`}
          element={
            <SuspensedView>
              <MyProfile />
            </SuspensedView>
          }
        />
        <Route
          path={`/pending-requests`}
          element={
            <SuspensedView>
              <PendingRequests />
            </SuspensedView>
          }
        />
        {/* <Route
          path={`/pod-:id/onboarding/:type/:job_join_id`}
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={myExpensesTitle}>Onboardings</PageTitle>
              <EmpDetailsMain />
            </SuspensedView>
          }
        /> */}
        <Route
          path={`/:id/templates`}
          element={
            <SuspensedView>
              <TemplatesMain />
            </SuspensedView>
          }
        />
        <Route
          path={`/:id/documents/*`}
          element={
            <SuspensedView>
              <DocsRoute />
            </SuspensedView>
          }
        />

        <Route
          path={`/:id/templates/:temp_id`}
          element={
            <SuspensedView>
              {/* <Template1Main /> */}
              <TempInfo />
            </SuspensedView>
          }
        />
        <Route
          path={`/:id/team-members`}
          element={
            <SuspensedView>
              <TeamMembersMain />
              {/* <TeamMembersTable /> */}
            </SuspensedView>
          }
        />

        <Route
          path={`/:id/api-tokens`}
          element={
            <SuspensedView>
              <ApiTokensMain />
            </SuspensedView>
          }
        />

        <Route
          path='crafted/pages/profile/*'
          element={<SuspensedView>{/* <ProfilePage /> */}</SuspensedView>}
        />
        <Route
          path='crafted/pages/wizards/*'
          element={<SuspensedView>{/* <WizardsPage /> */}</SuspensedView>}
        />
        <Route
          path='crafted/widgets/*'
          element={<SuspensedView>{/* <WidgetsPage /> */}</SuspensedView>}
        />
        <Route
          path='crafted/account/*'
          element={<SuspensedView>{/* <AccountPage /> */}</SuspensedView>}
        />
        <Route path='apps/chat/*' element={<SuspensedView>{/* <ChatPage /> */}</SuspensedView>} />
        <Route
          path='apps/user-management/*'
          element={<SuspensedView>{/* <UsersPage /> */}</SuspensedView>}
        />
        <Route
          path={`/:id/configuration/*`}
          element={
            <SuspensedView>
              <ConfigurationRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='/accounts'
          element={
            <SuspensedView>
              {
                <div>
                  <h1>Accounts</h1>
                </div>
              }
            </SuspensedView>
          }
        />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
